import React from "react";
import { createPortal } from "react-dom";
import "../styles/LoadingOverlay.css";

const LoadingOverlay = ({ message = "Cargando..." }) => {
  // 50% de probabilidad de mostrar el camión A o B
  const [truckType] = React.useState(() => (Math.random() > 0.5 ? "A" : "B"));

  return createPortal(
    <div className="loading-overlay">
      <div className="truck-wrapper">
        <svg
          className="truck"
          viewBox="0 0 100 50" /* Ajustado viewport para mejor detalle */
          width="120px"
          height="60px"
        >
          {truckType === "A" ? (
            /* CAMIÓN A: Cabina Roja, Trailer Azul Claro (Convencional) */
            <g className="truck-a">
              {/* Trailer */}
              <rect
                x="2"
                y="10"
                width="60"
                height="30"
                fill="#93c5fd"
                stroke="#60a5fa"
                strokeWidth="1"
                rx="2"
              />
              <line
                x1="10"
                y1="10"
                x2="10"
                y2="40"
                stroke="#bfdbfe"
                strokeWidth="1"
              />
              <line
                x1="20"
                y1="10"
                x2="20"
                y2="40"
                stroke="#bfdbfe"
                strokeWidth="1"
              />
              <line
                x1="30"
                y1="10"
                x2="30"
                y2="40"
                stroke="#bfdbfe"
                strokeWidth="1"
              />
              <line
                x1="40"
                y1="10"
                x2="40"
                y2="40"
                stroke="#bfdbfe"
                strokeWidth="1"
              />
              <line
                x1="50"
                y1="10"
                x2="50"
                y2="40"
                stroke="#bfdbfe"
                strokeWidth="1"
              />
              {/* Conector */}
              <rect x="62" y="30" width="6" height="4" fill="#334155" />
              {/* Cabina */}
              <path
                d="M68,40 L68,22 L76,14 L90,14 L90,40 Z"
                fill="#ef4444"
                stroke="#dc2626"
                strokeWidth="1"
              />
              <rect
                x="90"
                y="28"
                width="4"
                height="12"
                fill="#ef4444"
                stroke="#dc2626"
                strokeWidth="1"
              />{" "}
              {/* Nariz */}
              {/* Ventana */}
              <path d="M76,16 L88,16 L88,24 L76,24 Z" fill="#fee2e2" />
              {/* Ruedas */}
              <g className="truck-wheels">
                <circle
                  cx="15"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />
                <circle
                  cx="28"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />
                <circle
                  cx="41"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />

                <circle
                  cx="76"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />
                <circle
                  cx="88"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />

                {/* Rines */}
                <circle
                  cx="15"
                  cy="42"
                  r="2"
                  fill="#94a3b8"
                  className="wheel-rim"
                />
                <circle
                  cx="28"
                  cy="42"
                  r="2"
                  fill="#94a3b8"
                  className="wheel-rim"
                />
                <circle
                  cx="41"
                  cy="42"
                  r="2"
                  fill="#94a3b8"
                  className="wheel-rim"
                />
                <circle
                  cx="76"
                  cy="42"
                  r="2"
                  fill="#94a3b8"
                  className="wheel-rim"
                />
                <circle
                  cx="88"
                  cy="42"
                  r="2"
                  fill="#94a3b8"
                  className="wheel-rim"
                />
              </g>
            </g>
          ) : (
            /* CAMIÓN B: Cabina Amarilla, Contenedor Azul Oscuro (Cab-over) */
            <g className="truck-b">
              {/* Contenedor */}
              <rect
                x="4"
                y="6"
                width="64"
                height="34"
                fill="#1e3a8a"
                stroke="#172554"
                strokeWidth="1"
                rx="1"
              />
              {/* Detalles contenedor */}
              <line
                x1="4"
                y1="12"
                x2="68"
                y2="12"
                stroke="#172554"
                strokeWidth="1"
                opacity="0.5"
              />
              <line
                x1="4"
                y1="18"
                x2="68"
                y2="18"
                stroke="#172554"
                strokeWidth="1"
                opacity="0.5"
              />
              <line
                x1="4"
                y1="24"
                x2="68"
                y2="24"
                stroke="#172554"
                strokeWidth="1"
                opacity="0.5"
              />
              <line
                x1="4"
                y1="30"
                x2="68"
                y2="30"
                stroke="#172554"
                strokeWidth="1"
                opacity="0.5"
              />
              {/* Chasis conector */}
              <rect x="20" y="40" width="40" height="4" fill="#334155" />
              {/* Cabina */}
              <path
                d="M70,40 L70,12 L92,12 C95,12 96,14 96,18 L96,40 Z"
                fill="#f59e0b"
                stroke="#d97706"
                strokeWidth="1"
              />
              {/* Ventana */}
              <path d="M82,16 L92,16 L92,26 L82,26 Z" fill="#fef3c7" />
              <rect
                x="72"
                y="28"
                width="10"
                height="8"
                fill="none"
                stroke="#b45309"
                strokeWidth="1"
                opacity="0.5"
                rx="1"
              />{" "}
              {/* Puerta */}
              {/* Ruedas */}
              <g className="truck-wheels">
                <circle
                  cx="16"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />
                <circle
                  cx="28"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />

                <circle
                  cx="84"
                  cy="42"
                  r="5"
                  fill="#1e293b"
                  className="wheel"
                />

                {/* Rines */}
                <circle
                  cx="16"
                  cy="42"
                  r="2"
                  fill="#cbd5e1"
                  className="wheel-rim"
                />
                <circle
                  cx="28"
                  cy="42"
                  r="2"
                  fill="#cbd5e1"
                  className="wheel-rim"
                />
                <circle
                  cx="84"
                  cy="42"
                  r="2"
                  fill="#cbd5e1"
                  className="wheel-rim"
                />
              </g>
            </g>
          )}

          {/* Líneas de viento comunes */}
          <g className="wind-lines">
            <line
              x1="0"
              y1="20"
              x2="10"
              y2="20"
              stroke="#cbd5e1"
              strokeWidth="1"
              className="wind wind-1"
            />
            <line
              x1="-5"
              y1="30"
              x2="5"
              y2="30"
              stroke="#cbd5e1"
              strokeWidth="1"
              className="wind wind-2"
            />
          </g>
        </svg>
      </div>
      <span className="loading-text">{message}</span>
    </div>,
    document.body,
  );
};

export default LoadingOverlay;
